'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Recruit;
(function (Recruit) {
    var MyRecruit = /** @class */ (function () {
        function MyRecruit() {
            $('.trigOpenInfo').on('click', function () {
                var open = Number($(this).attr('data-open'));
                if (open == 0) {
                    $(this).find('i').removeClass('fa-plus');
                    $(this).find('i').addClass('fa-minus');
                    $(this).next().slideDown();
                    $(this).attr('data-open', 1);
                }
                else {
                    $(this).find('i').removeClass('fa-minus');
                    $(this).find('i').addClass('fa-plus');
                    $(this).next().slideUp();
                    $(this).attr('data-open', 0);
                }
            });
        }
        return MyRecruit;
    }());
    Recruit.MyRecruit = MyRecruit;
})(Recruit || (Recruit = {}));
exports.default = Recruit;
